const closeMapPopup = () => {
  let mapPopups = document.querySelectorAll('.leaflet-popup-close-button');
  mapPopups = Array.from(mapPopups);

  mapPopups.forEach(el => {
    el.click();
  });
};

export default closeMapPopup;
